import { render } from "./App.vue?vue&type=template&id=c544a302"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"desktope/core/head/search/search-autocomplete/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c544a302"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c544a302', __exports__)) {
    api.reload('c544a302', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=c544a302", () => {
    api.rerender('c544a302', render)
  })

}


export default __exports__